module.exports = __webpack_public_path__ + "static/media/am_ticket.e4004801.svg";